import React from 'react';

import DashboardLayout from '../layouts/Dashboard/Dashboard';

import MyProfile from '../components/MyProfile/MyProfile';
import { notifications } from '../components/Dashboard/testData';
import CustomerDataProvider from '../contexts/CustomerDataProvider';
import {setPageTitle} from '../utils/helpers';

const MyProfilePageContainer = () => {
  setPageTitle('My Profile | Investec Save');

  return (
    <CustomerDataProvider>
      <DashboardLayout notifications={notifications} className="my-profile-page">
        <MyProfile />
      </DashboardLayout>
    </CustomerDataProvider>
  );

};

export default MyProfilePageContainer;
